module.exports = __webpack_public_path__ + "img/contact-wx-code.d504198f.jpg";